// assets/fixed-header.js
document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector('[data-scroll-header]');
    const isMobile = () => window.innerWidth <= 991;
  
    function updateHeaderHeight() {
      if (isMobile()) {
        const headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-mobile', headerHeight + 'px');
      }
    }
  
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
  
    window.addEventListener('scroll', function () {
      if (!isMobile()) return;
  
      if (window.pageYOffset > 100) {
        header.classList.add('is-fixed');
        document.body.classList.add('has-fixed-header');
      } else {
        header.classList.remove('is-fixed');
        document.body.classList.remove('has-fixed-header');
      }
    });
  });
  